import Mainmenu from './components/mainmenu';
Mainmenu.init();

import ReferredNotice from './components/referred-notice';
ReferredNotice.init();

import CountrySelector from './components/countrySelector';
CountrySelector.init();

import SearchFilters from './components/SearchFilters';
SearchFilters.init();

import toggleContent from './util/toggleContent';
toggleContent.init();

import searchFocus from './util/searchFocus';
searchFocus.init();

import contactModalWrapper from './components/contactModal';
contactModalWrapper.init();

import contactModalFloatingButton from './components/contactModalFloatingButton';
contactModalFloatingButton.init();

import ReklamasjonsSkjema from './components/reklamasjonsSkjema';
ReklamasjonsSkjema.init();

// AJAX version of reklamasjonsSkjema. Not used for now
//import processReklamasjonsSkjema from './components/processReklamasjonsSkjema';
//processReklamasjonsSkjema.init();

import formTracking from './components/FormTracking';
formTracking();
